/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=4d5f29ee"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4d5f29ee&lang=css"

import exportComponent from "F:\\zhangshuo\\huzhonghuang\\hzh1\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__